// src/features/files/components/SelectFileDialog/SearchBar.jsx
import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * SearchBar - File search input
 */
export function SearchBar({
  searchQuery,
  onSearchChange,
}) {
  const { t } = useTranslation(['files', 'common']);

  return (
    <TextField
      fullWidth
      placeholder={t('files:search_placeholder')}
      value={searchQuery}
      onChange={(e) => onSearchChange(e.target.value)}
      size="small"
    />
  );
}
